import { useEffect, useState } from "react";
import { useGetFPOListQuery } from "features/onboarding/organizations/FarmersGroup/FPO/FPOApiSlice";
import { useParams, useNavigate } from "react-router-dom";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import useDebouncedValue from "hooks/useDebouncedValue";
import { Grid, Card, CardContent, Typography, Stack, Box } from "@mui/material";
import SkeletonLoader from "features/Procurement/common/SkeletonLoader";
import NoResponse from "./NoResponse";
import {  selectLanguage, setLanguage } from "features/auth/authSlice";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
const ProjectFpoTab = ({ projectExist, cards, orgAdmin }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const orgId = id ? id : "";
   const { t, i18n } = useTranslation();
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pageCount: 0 });
  const [searchKey, setSearchKey] = useState("");
  const debouncedSearch = useDebouncedValue(searchKey);
  const { data: data, isLoading, refetch } = useGetFPOListQuery({
    pagination,
    searchKey: debouncedSearch || "",
    orgId,
  });
  useEffect(() => {
    const dataFromApi = data?.data?.results ? data?.data?.results : [];
    const paginationFromApi = data?.data?.pages
      ? { page: data?.data?.current_page, pageCount: data?.data?.pages }
      : pagination;

    setUsers(dataFromApi);
    setPagination(paginationFromApi);
  }, [data]);
  return (
    <div className=" ">
      {isLoading ? (
        <SkeletonLoader />
      ) : users?.length > 0 ? (
        <Grid container spacing={2}>
          {users?.map((project, index) => (
            <Grid item xs={12} key={index}>
              <Card
                variant="outlined"
                sx={{
                  position: "relative",
                  backgroundColor: "#ffffff",
                  borderLeft: "4px solid #f57c00",
                  borderRight: "4px solid #f57c00",
                  borderRadius: 3,
                  boxShadow: "0 6px 12px rgba(0,0,0,0.08)",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 12px 24px rgba(0,0,0,0.12)",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: "10%",
                    right: 12,
                    backgroundColor: "#f57c00",
                    color: "white",
                    fontSize: "0.75rem",
                    padding: "4px 10px",
                    borderRadius: 1,
                    cursor: "pointer",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    "&:hover": {
                      backgroundColor: "#e65100",
                    },
                  }}
                  onClick={() =>
                    navigate(
                      `/project/dashboard/farmers-group/FPO/${project.id}`,
                      // `/project/dashboard/${project.id}`,

                      {
                        state: {
                          projectExist,
                          cards,
                          orgAdmin,
                        },
                      }
                    )
                  }
                >
                  {t("View Details")}
                </Box>

                <CardContent>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={3}>
                      <Typography
                        variant="h6"
                        fontWeight={600}
                        sx={{ color: "#333" }}
                      >
                        📋 {project.organization_name}
                      </Typography>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        className="mx-2"
                      >
                         {t("Created on")}:
                        {project?.created_at
                          ? new Date(project.created_at).toLocaleDateString()
                          : "-"}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Stack
                        direction="row"
                        flexWrap="wrap"
                        gap={1}
                        justifyContent="start"
                      >
                        <Typography variant="body2" color="text.secondary">
                          <PhoneIcon
                            fontSize="small"
                            sx={{ mr: 0.5, color: "#eda946" }}
                          />
                          {project.phone_number || "N/A"}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          <EmailIcon
                            fontSize="small"
                            sx={{ mr: 0.5, color: "#eda946" }}
                          />
                          {project.email || "N/A"}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          📍{" "}
                          {project?.project?.states
                            ?.map((s) => s.label)
                            .join(", ") || "-"}
                        </Typography>
                      </Stack>
                    </Grid>
                    {!projectExist?.showCustomUiDesign ? (
                      <Grid item xs={12} sm={3}>
                        <Typography
                          variant="body2"
                          fontWeight={500}
                          gutterBottom
                        >
                          🌾 Crops:
                        </Typography>
                        <Stack direction="row" flexWrap="wrap" gap={1}>
                          {project?.project?.crops?.length ? (
                            project.project.crops.map((crop, i) => (
                              <Box
                                key={i}
                                sx={{
                                  px: 1.5,
                                  py: 0.5,
                                  fontSize: "0.75rem",
                                  backgroundColor: "#e3f2fd",
                                  color: "#0d47a1",
                                  borderRadius: "12px",
                                  fontWeight: 500,
                                }}
                              >
                                {crop}
                              </Box>
                            ))
                          ) : (
                            <Typography variant="body2" color="text.secondary">
                              -
                            </Typography>
                          )}
                        </Stack>
                      </Grid>
                    ) : (
                      <Grid item xs={12} sm={3}>
                        <Typography
                          variant="body2"
                          fontWeight={500}
                          gutterBottom
                        >
                          🌾  {t("Commodities")}:
                        </Typography>
                        <Stack direction="row" flexWrap="wrap" gap={1}>
                          {Array.isArray(
                            project?.project?.selectedCommodities
                          ) &&
                          project.project.selectedCommodities.length > 0 ? (
                            project.project.selectedCommodities.map(
                              (crop, i) => (
                                <Box
                                  key={i}
                                  sx={{
                                    px: 1.5,
                                    py: 0.5,
                                    fontSize: "0.75rem",
                                    backgroundColor: "#e3f2fd",
                                    color: "#0d47a1",
                                    borderRadius: "12px",
                                    fontWeight: 500,
                                  }}
                                >
                                  {crop.name}
                                </Box>
                              )
                            )
                          ) : (
                            <Typography variant="body2" color="text.secondary">
                              -
                            </Typography>
                          )}
                        </Stack>
                      </Grid>
                    )}
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <NoResponse />
      )}
    </div>
  );
};

export default ProjectFpoTab;
